export default "__VITE_ASSET__d32b2fde__"